


<div>
  <tabset>
    <tab heading="HeadQuarters">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.pageTitle' | translate}}
            </h3>
            <p><strong>Kenneth Hahn Hall of Administration</strong></p>
            <p>500 W. Temple Street, Room 225</p>
            <p>Los Angeles, CA 90012-2770</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(213) 974-3211</p>
            <p>(888) 807-2111 toll-free</p>
            <p>Si necesita asistencia en Español, por favor llame gratis al (888) 807-2111 y oprima "2" al escuchar el mensaje.</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>
            <p><i>Must be in line by 4:45pm</i></p>
          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[0].lat" [longitude]="markers[0].lng" [markerTitle]="'Hall of Administration'"></app-map-slice>
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <h5>Services</h5>
          <a (click)="HeadServices = !HeadServices" class="ml-auto">Hide</a>
        </div>
        <hr>
        <div [ngClass]="HeadServices ? 'active' : ''" class="row headquarters expandable">
          <table   class="table table-striped ">
            <tbody>
              <tr>
                <th>Administrative Services</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Management Services</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Personnel and Payroll</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Special Investigations</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Exemptions and Mapping</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
            </tbody>
          </table>
        </div>-->
      </div>

    </tab>
    <tab heading="North District">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.NorthPageTitle' | translate}}
            </h3>
            <p>13800 Balboa Boulevard</p>
            <p>Sylmar, CA 91342</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(818) 833-6000</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[1].lat" [longitude]="markers[1].lng" [markerTitle]="'North District'"></app-map-slice>
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <h5>Services</h5>
          <a (click)="HeadServices = !HeadServices" class="ml-auto">Hide</a>
        </div>
        <hr>
        <div [ngClass]="HeadServices ? 'active' : ''" class="row headquarters expandable">
          <table   class="table table-striped ">
            <tbody>
              <tr>
                <th>Real Property Appraisals Regions B1, 2 & 3</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Commercial Industrial Region 24</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Personal Property(Business & Audit)</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>

            </tbody>
          </table>
        </div>-->
      </div>
    </tab>
    <tab heading="East District">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.EastPageTitle' | translate}}
            </h3>
            <p>1190 Durfee Avenue</p>
            <p>South El Monte, CA 91733</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(626) 258-6001</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[2].lat" [longitude]="markers[2].lng" [markerTitle]="'East District'"></app-map-slice>
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <h5>Services</h5>
          <a (click)="HeadServices = !HeadServices" class="ml-auto">Hide</a>
        </div>
        <hr>
        <div [ngClass]="HeadServices ? 'active' : ''" class="row headquarters expandable">
          <table   class="table table-striped ">
            <tbody>
              <tr>
                <th>Real Property Appraisals Regions 4, 5, 6, & 11</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Commercial Industrial Region 27</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Personal Property(Business & Audit) Area 4</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>

            </tbody>
          </table>
        </div>-->
      </div>
    </tab>
    <tab heading="South District">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.SouthPageTitle' | translate}}
            </h3>
            <p>1401 E. Willow Street</p>
            <p>Signal Hill, CA 90755</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(562) 256-1701</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[3].lat" [longitude]="markers[3].lng" [markerTitle]="'South District Office'"></app-map-slice>
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <h5>Services</h5>
          <a (click)="HeadServices = !HeadServices" class="ml-auto">Hide</a>
        </div>
        <hr>
        <div [ngClass]="HeadServices ? 'active' : ''" class="row headquarters expandable">
          <table   class="table table-striped ">
            <tbody>
              <tr>
                <th>Real Property Appraisals Regions 10, 12, & 14</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Commercial Industrial Region 26</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Personal Property(Business & Audit) Area 3</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>

            </tbody>
          </table>
        </div>-->
      </div>
    </tab>
    <tab heading="West Regional">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.WestPageTitle' | translate}}
            </h3>
            <!-- <p style="color:red"><strong>Public services are temporarily moved to: </strong></p>
            <p><strong>Kenneth Hahn Hall of Administration, Room 225.</strong></p><p><i>Room 183-19 (mailing address)</i></p> -->
            <p>6167 Bristol Parkway, Suite 100</p>
            <p>Culver City, CA 90230</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(310) 665-5300</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>
            <!-- <p><i>Must be in line by 4:45pm</i></p> -->

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[4].lat" [longitude]="markers[4].lng" [markerTitle]="'West Regional Office'"></app-map-slice>
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <h5>Services</h5>
          <a (click)="HeadServices = !HeadServices" class="ml-auto">Hide</a>
        </div>
        <hr>
        <div [ngClass]="HeadServices ? 'active' : ''" class="row headquarters expandable">
          <table   class="table table-striped ">
            <tbody>
              <tr>
                <th>Real Property Appraisals Regions 7 & 9</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Commercial Industrial Region 25</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>
              <tr>
                <th>Personal Property(Business & Audit) Area 2</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>

            </tbody>
          </table>
        </div>-->
      </div>
    </tab>
    <tab heading="Lancaster Regional">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.LancasterPageTitle' | translate}}
            </h3>
            <p>251 E. Avenue K6</p>
            <p>Lancaster, CA 93535</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(661) 940-6700</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[5].lat" [longitude]="markers[5].lng" [markerTitle]="'Lancaster Regional Office'"></app-map-slice>
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <h5>Services</h5>
          <a (click)="HeadServices = !HeadServices" class="ml-auto">Hide</a>
        </div>
        <hr>
        <div [ngClass]="HeadServices ? 'active' : ''" class="row headquarters expandable">
          <table   class="table table-striped ">
            <tbody>
              <tr>
                <th>Real Property Appraisals Regions A1</th>
                <th><a href="mailto:email@assessor.lacounty.gov">email@assessor.lacounty.gov</a></th>
              </tr>

            </tbody>
          </table>
        </div>-->
      </div>
    </tab>
  </tabset>
</div>





